/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { fromPairs, compact } from 'lodash';
import { CredentialAttrMeta } from 'blb-constants/ron';
import { DateTime } from 'luxon';
import { DATE_ISO_FORMAT, DATE_US_FORMAT } from 'blb-components/AuthenticatedApp/RON/CredentialInfo/dateUtils';
const transformCredentialMeta = (meta, transform) => {
  if (!meta) {
    return {};
  }
  return fromPairs(compact(Object.entries(meta).map(_ref => {
    let [key, value] = _ref;
    if (value === null || value === undefined) {
      return;
    }
    const attrMeta = CredentialAttrMeta[key];
    if (attrMeta) {
      return [key, transform(attrMeta, value)];
    }
  })));
};

/** Format date value from ISO format to US locale for displaying in <TextInput> component */
export const formatCredentialMeta = meta => {
  return transformCredentialMeta(meta, (attrMeta, value) => {
    if (attrMeta.type === 'date') {
      return formatCredentialDate(value, DATE_ISO_FORMAT, DATE_US_FORMAT);
    } else {
      return value;
    }
  });
};

/** Transform date value from US locale format to ISO format before sending back to backend */
export const normalizeCredentialMeta = meta => {
  return transformCredentialMeta(meta, (attrMeta, value) => {
    if (attrMeta.type === 'date') {
      return formatCredentialDate(value, DATE_US_FORMAT, DATE_ISO_FORMAT);
    } else {
      return value;
    }
  });
};
export const formatCredentialDate = (value, fromFormat, toFormat) => {
  if (!value) {
    return;
  }
  const result = DateTime.fromFormat(value, fromFormat).toFormat(toFormat);
  return result === 'Invalid DateTime' ? undefined : result;
};